import { BadRequestError } from '@cian/valuation-utils-component';

import { TThunkAction } from '../../types/redux';
import { ISubmitProps } from '../../containers/FormContainer/types/internal';
import { mapAnswersState } from './utils/mapAnswersState';
import { TFormSubmitResult, TMappedAnswersState } from './types';
import { prepareErrorMeta } from './utils/prepareErrorMeta';
import { getErrorMessageFromError } from './utils/getErrorMessageFromError';
import { fetchTrackingBankiru } from '../tracking/fetchTrackingBankiru';
import { isLimitExceed } from './utils/isLimitExceed';
import { createPersonalRequest } from './utils/createPersonalRequest';
import { createRequest } from './utils/createRequest';
import { createConsultationRequest } from './utils/createСonsultationRequest';

export const submitForm =
  (props: ISubmitProps): TThunkAction<Promise<TFormSubmitResult | Error>> =>
  async (dispatch, getState, { httpApi, logger, config }) => {
    const mappedAnswersState: TMappedAnswersState = mapAnswersState(props);
    const state = getState();
    const {
      intro: { fromBankiru, transactionId },
    } = state;

    try {
      let createMessageData;

      if (mappedAnswersState.wantToChooseRealtor) {
        createMessageData = await createPersonalRequest({ httpApi, mappedAnswersState, state });
      } else if (mappedAnswersState.cooperationStatus) {
        // TODO: необходимо удалить этот функционал и интерфейсы ручки
        createMessageData = await createConsultationRequest({ httpApi, mappedAnswersState });
      } else {
        createMessageData = await createRequest({ httpApi, mappedAnswersState, state, config });
      }

      if (createMessageData.statusCode === 200) {
        if (fromBankiru && transactionId) {
          const { id } = createMessageData.response;
          await dispatch(fetchTrackingBankiru(id, transactionId));
        }

        return createMessageData.response;
      }

      throw createMessageData.response;
    } catch (error) {
      if (isLimitExceed(error.errors)) {
        const err = new BadRequestError({
          message: error.message,
          domain: 'submitForm.ts',
          details: {
            errors: JSON.stringify(error.errors),
          },
        });
        logger.warning(err, {
          message: 'Limit on the number of applications has been exceeded',
        });
      } else {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const meta = prepareErrorMeta({ mappedAnswersState, error }) as any;

        logger.error(error, meta);
      }

      const errorMessage = getErrorMessageFromError(error);

      return new Error(errorMessage);
    }
  };
